import { readState, recoveringRead } from './recoveringRead.js'

export function projectReads(loaders, data, states, now = Date.now) {
  const readers = Object.fromEntries(Object.entries(loaders).map(([key, read]) => {
    states[key] = { ...readState(), updatedAt: null }
    return [key, recoveringRead(read, value => {
      data[key] = value
      states[key].updatedAt = now()
    }, states[key], { now })]
  }))
  return {
    load: (options = {}) => Promise.all(Object.values(readers).map(reader => reader.run(options))),
    stop: () => Object.values(readers).forEach(reader => reader.stop()),
  }
}
